var e = {
	noAccess: "Ask someone with the Manage Developer Access permission to request this.",
	unavailable: "Developer API keys aren't available in this environment yet. See the Get access guide in the developer docs.",
	state: {
		none: {
			title: "No developer access yet",
			body: "Request API access to build your own integrations against your workspace's data.",
			request: "Request developer access"
		},
		requested: {
			title: "Your request is with Maat",
			body: "We'll let you know once it's reviewed. Requested {{date}}."
		},
		declined: {
			title: "Request declined",
			reason: "Reason: {{reason}}",
			requestAgain: "Request again"
		},
		accepted: {
			title: "Read and sign the Developer Terms",
			body: "Maat approved your request. Read and sign the Developer Terms to start issuing keys.",
			reviewTerms: "Review the Developer Terms"
		},
		active: {
			title: "Developer access active",
			signedOn: "Terms {{version}} signed {{date}}",
			termsUpdated: "The Developer Terms have been updated to version {{version}}. Your keys keep working, but no new key can be issued until the updated Terms are signed.",
			reviewUpdatedTerms: "Review and sign the updated Terms",
			termsUpdatedNoAccess: "Ask someone with the Manage Developer Access permission to sign the updated Terms."
		},
		revoked: {
			title: "Developer access withdrawn",
			body: "Your keys have stopped working. Contact Maat if you believe this is a mistake."
		}
	},
	terms: {
		title: "Developer Terms",
		version: "Version {{version}}",
		effectiveDate: "Effective {{date}}",
		englishNotice: "Presented in English only — the English text is the binding one.",
		acknowledge: "I have read and agree to the Developer Terms.",
		sign: "Sign",
		signed: "Developer Terms signed",
		signError: "Failed to sign the Developer Terms",
		unavailable: "The Developer Terms aren't available in this environment. Nothing can be signed until they are.",
		loadError: "Couldn't load the Developer Terms.",
		validation: { acknowledgeRequired: "Acknowledge the Developer Terms to continue" },
		retry: "Try again"
	},
	keys: {
		issue: "Issue key",
		status: {
			active: "Active",
			revoked: "Revoked",
			expired: "Expired"
		},
		rotate: "Rotate",
		rotateConfirmTitle: "Rotate {{name}}?",
		rotateConfirmBody: "A new secret is issued immediately and the current one stops working. Update your integration before rotating.",
		revoke: "Revoke",
		revokeConfirmTitle: "Revoke {{name}}?",
		revokeConfirmBody: "This takes effect immediately and cannot be undone.",
		rotateError: "Failed to rotate the key",
		revokeError: "Failed to revoke the key",
		revoked: "Revoked {{name}}",
		copied: "I've copied it — done",
		secretWarning: "This is the only time {{name}}'s secret will be shown. Copy it now — it is stored only as a hash and cannot be retrieved again. If you lose it, rotate the key to issue a new one.",
		secretHint: "Send it as an Authorization: Bearer header. Treat it like a password: never commit it, and store it in your integration's secret manager.",
		actions: "Actions for {{name}}",
		created: "Created {{date}}",
		expires: "Expires {{date}}",
		expired: "Expired {{date}}",
		lastUsed: "Last used {{date}}",
		neverUsed: "Never used",
		emptyTitle: "No keys in this environment",
		emptyBody: "Issue a key to start calling the API. Its secret is shown once, when you issue it.",
		retired_one: "{{count}} revoked or expired key",
		retired_other: "{{count}} revoked or expired keys",
		scopesMore: "+{{count}} more",
		scopesLess: "Show fewer",
		viewRequests: "View requests"
	},
	issueKey: {
		title: "Issue developer key",
		nameLabel: "Name",
		namePlaceholder: "e.g. inventory-sync",
		nameHint: "How you'll recognise this key later — the secret is shown only once.",
		environmentLabel: "Environment",
		scopesLabel: "Scopes",
		scopesHint: "Grant only what this integration needs. A scope you don't have the permission for is disabled.",
		alwaysIncludedNote: "The token exchange ({{scope}}) is always included and does not need to be selected.",
		scopeDisabledHint: "Requires a permission you don't hold",
		expiresAtLabel: "Expires at (optional)",
		expiresAtHint: "Leave blank for the default (365 days). A key may not outlive that ceiling.",
		submit: "Issue key",
		submitError: "Failed to issue the key",
		issuedTitle: "Key issued",
		validation: {
			nameRequired: "Give the key a recognisable name",
			scopesMin: "Select at least one scope",
			scopeNotGrantable: "Includes a scope you don't have the permission for"
		},
		environmentLockedHint: "Set by the Live / Sandbox switch on the console. Change it there to issue a key for the other environment."
	},
	webhook: { unavailable: "Webhook signing isn't configured in this environment yet." },
	deliveries: {
		columns: {
			attempts: "Attempts",
			lastError: "Last error"
		},
		detail: {
			title: "Delivery",
			loadErrorTitle: "We couldn't load this delivery",
			loadErrorBody: "Something went wrong reading this delivery.",
			eventId: "Event ID",
			nextAttempt: "Next attempt",
			none: "—",
			payload: {
				label: "Body we sent",
				redacted: "The guest exercised their right to erasure before this delivery went out, so the body was destroyed. It will never be sent.",
				purged: "This body is no longer held: it either aged out of the window we keep delivery payloads for, or it was destroyed by an erasure after the delivery had already settled. There is nothing left to send."
			},
			redrive: {
				action: "Redrive",
				confirmTitle: "Redrive this delivery?",
				confirmBody: "We'll send this event to your endpoint again, with the same event ID and a fresh attempt count.",
				success: "Delivery queued for redrive",
				remaining_one: "{{count}} redrive left today",
				remaining_other: "{{count}} redrives left today",
				genericError: "Failed to redrive this delivery",
				errors: {
					not_found: "This delivery is no longer in your webhook history.",
					in_flight: "This delivery is already queued or being sent. Wait for it to settle, then redrive it if it still needs one.",
					race_lost: "This delivery changed while this page was open. Close and reopen it to see where it is now.",
					payload_redacted: "This delivery has no body left: the guest asked to be erased before it was delivered, so it was destroyed. There is nothing to send.",
					payload_purged: "This delivery has no body left — it is past the window we keep payloads for. There is nothing to send.",
					endpoint_inactive: "Your endpoint is not active, so nothing would be delivered. Register it again and answer the challenge first.",
					budget_exhausted: "You've used your redrive allowance for the last 24 hours. It rolls forward continuously rather than resetting at midnight."
				}
			},
			signature: {
				label: "Signature headers we sent",
				hint: "Re-run your verifier against the body above using these. Your signing secret is never stored, so it is not shown here."
			},
			emptyTitle: "Select a delivery",
			emptyBody: "Pick any delivery to see the body we sent and the signature on it.",
			deliveredAt: "Delivered",
			bookingReference: "Booking reference"
		},
		emptyFiltered: "No deliveries match this status.",
		testBadge: "Test",
		attempts_one: "{{count}} attempt",
		attempts_other: "{{count}} attempts",
		emptyTitle: "No deliveries yet",
		emptyBody: "Events for this environment show up here as they're sent. Send a test event from the Endpoint tab to see one now.",
		loadErrorTitle: "We couldn't load your deliveries",
		loadErrorBody: "Something went wrong reading this list."
	},
	requests: {
		retention: "API history is retained for {{days}} days.",
		emptyTitle: "No API requests yet",
		empty: "Nothing here yet — this fills up as soon as your keys start calling the API.",
		emptyFiltered: "No requests match these filters.",
		emptyFilteredBody: "Try a wider date range, or clear the filters to see everything.",
		clearFilters: "Clear filters",
		moreFilters: "More filters",
		loadErrorTitle: "We couldn't load your API history",
		loadErrorBody: "Something went wrong reading this list.",
		filters: {
			allMethods: "All methods",
			allStatuses: "All statuses",
			allRoutes: "All endpoints",
			searchRoutes: "Search endpoints",
			apiKey: "Key",
			allKeys: "All keys",
			statusCode: "Status code",
			statusCodePlaceholder: "e.g. 403",
			dateRange: "Date range",
			allFailures: "All failures",
			searchPlaceholder: "Request ID or path, e.g. /v1/listings"
		},
		copyRequestId: "Copy request ID",
		copiedRequestId: "Request ID copied",
		detail: {
			title: "Request",
			request: "Request",
			response: "Response",
			queryLabel: "Query",
			noBody: "No body was sent.",
			noResponseBody: "No body was returned.",
			notStored: "Not stored. This endpoint answers with a credential, so its body is never written down.",
			requestNotStored: "Not stored. This endpoint takes no body.",
			truncated: "This body was {{bytes}} bytes and was over the 64 KB limit, so it was not stored.",
			loadError: "We couldn't load this request.",
			scope: "Required scope",
			userAgent: "User agent",
			clientIp: "Client IP",
			contentType: "Content type",
			requestId: "Request ID",
			none: "—",
			retryAfter: "Retry after",
			key: "Key",
			emptyTitle: "Select a request",
			emptyBody: "Pick any request to see what was sent, what we answered and why.",
			copyCurl: "Copy as cURL",
			curlCopied: "cURL command copied. Set MAAT_ACCESS_TOKEN before you run it.",
			moreActions: "More actions",
			filterRoute: "Show requests to this endpoint",
			filterKey: "Show this key's requests",
			fieldErrors_one: "{{count}} field was refused",
			fieldErrors_other: "{{count}} fields were refused"
		},
		count_one: "{{count}} request",
		count_other: "{{count}} requests",
		live: "Live",
		refresh: "Refresh",
		updatedAt: "Updated {{time}}"
	},
	sandbox: {
		neverReset: "Never reset",
		reset: "Reset sandbox",
		resetConfirmTitle: "Reset your sandbox?",
		resetConfirmBody: "Every property, booking and setting in your sandbox is wiped back to a clean slate. Your Live workspace is not affected.",
		resetSuccess: "Sandbox reset",
		resetError: "Failed to reset the sandbox",
		notProvisioned: "Your sandbox is still being provisioned."
	},
	loadErrorTitle: "We couldn't load your developer settings",
	loadErrorBody: "Something went wrong reading this page.",
	retry: "Try again",
	manageOnly: "You need the Manage Developer Access permission to do this. Ask a workspace owner to grant it.",
	errors: {
		keys_disabled: "Developer API keys aren't configured in this environment yet. See the Get access guide in the developer docs.",
		partner_not_found: "This workspace has no developer record.",
		agreement_not_recorded: "No signed agreement is on file for this workspace yet.",
		bind_failed: "The key was not issued. Nothing changed — try again.",
		developer_access_required: "This workspace doesn't have active developer access.",
		developer_access_required_accepted: "Read and sign the Developer Terms before issuing a key.",
		developer_access_not_found: "This workspace has never requested developer access.",
		developer_access_not_accepted: "Maat has not accepted this request yet, so there is nothing to sign.",
		developer_access_revoked: "Developer access for this workspace has been withdrawn. Contact Maat.",
		terms_unavailable: "The Developer Terms aren't available in this environment. Nothing can be signed until they are.",
		terms_version_stale: "The Developer Terms have been updated. Sign the current version and try again.",
		sandbox_not_provisioned: "This workspace has no sandbox yet.",
		sandbox_reset_in_progress: "A sandbox reset is already running. Try again shortly.",
		sandbox_workspace: "A sandbox workspace cannot request developer access.",
		scope_not_permitted: "You cannot grant \"{{scope}}\" — it needs the \"{{permission}}\" permission, which you don't hold.",
		expiry_too_far: "A developer key may not outlive its 365-day ceiling.",
		not_found: "That key no longer exists, or has already been revoked.",
		endpoint_not_registered: "There is no registered endpoint. Register one and answer the challenge first.",
		endpoint_inactive: "Your endpoint is not active. Register it again and answer the challenge first.",
		event_not_available: "That event isn't one you can subscribe to.",
		test_event_budget_exhausted: "You've used your test-event allowance for the last 24 hours. It rolls forward continuously; try again later.",
		endpoint_refused: "The URL was rejected. It must be an https URL on a publicly resolvable host, on port 443 or 8443.",
		signing_not_configured: "Webhook signing is not configured on the platform right now. Nothing changed; try again later."
	},
	console: { sandboxBand: {
		title: "You're looking at the sandbox",
		body: "Sandbox keys, endpoint and deliveries. Nothing here reaches a real guest or a real booking, and you can reset it any time from the Sandbox page.",
		guide: "What the sandbox can and cannot prove"
	} },
	overview: {
		title: "Developer",
		description: "Keys, webhooks and logs for this workspace's integrations.",
		requests: {
			title: "API requests",
			total: "Requests",
			empty: "No requests yet",
			emptyBody: "Calls your keys make show up here within a minute.",
			viewLogs: "View logs",
			errorRate: "Error rate",
			p50: "p50 latency",
			p95: "p95 latency",
			succeeded: "Succeeded",
			clientErrors: "Client errors (4xx)",
			serverErrors: "Server errors (5xx)",
			window24h: "24h",
			window7d: "7d",
			windowDays: "{{days}}d"
		},
		keys: {
			title: "API keys",
			count_one: "{{count}} active key",
			count_other: "{{count}} active keys",
			none: "No keys in this environment yet",
			noneBody: "Issue one to start calling the API.",
			issue: "Issue a key",
			manage: "Manage keys",
			neverUsed: "Never used"
		},
		endpoint: {
			title: "Webhook endpoint",
			none: "No endpoint registered",
			noneBody: "Register one to receive events for this environment.",
			register: "Register endpoint",
			manage: "Manage webhooks",
			delivered: "delivered",
			failed: "failed",
			pending: "pending",
			oldest: "Oldest undelivered: {{date}}",
			lastChallengeError: "Last challenge error: {{error}} ({{date}})"
		},
		recentErrors: {
			title: "Recent errors",
			empty: "No failed requests",
			emptyBody: "Nothing your keys sent in the last {{days}} days was answered 4xx or 5xx.",
			viewAll: "See all in Logs"
		},
		resources: {
			title: "Resources",
			apiReference: "API reference",
			quickstart: "Quickstart",
			webhooks: "Webhooks guide",
			scopes: "Scopes",
			errors: "Error codes",
			changelog: "Changelog",
			ai: "Connect your AI assistant",
			descriptions: {
				quickstart: "Make your first authenticated call in a few minutes.",
				apiReference: "Every endpoint, parameter and response, with examples.",
				webhooks: "Receive events, verify their signatures and handle retries.",
				scopes: "What each scope lets a key do, and who may grant it.",
				errors: "Every error code we answer with, and what to do about it.",
				changelog: "What changed in the API, and when.",
				ai: "Let an AI assistant read the docs and write calls for you."
			}
		},
		failing: {
			title: "Failing endpoints",
			count_one: "{{count}} failure",
			count_other: "{{count}} failures",
			empty: "Nothing failing",
			emptyBody: "No endpoint answered your keys with a 4xx or 5xx in the last {{days}} days."
		}
	},
	keysPage: {
		title: "API keys",
		description: "Credentials for the selected environment. The secret is shown once, when a key is issued or rotated."
	},
	logs: {
		title: "API logs",
		description: "Every request this workspace's keys made to the API in the selected environment, and what we answered."
	},
	webhooks: {
		title: "Webhooks",
		description: "Where events for the selected environment are delivered, what was delivered, and the catalogue of events.",
		tabs: {
			endpoint: "Endpoint",
			deliveries: "Deliveries",
			events: "Events"
		},
		endpoint: {
			title: "Endpoint",
			verifiedAt: "Verified",
			lastChallengeError: "Last challenge error",
			events: "Subscribed events",
			empty: {
				title: "No endpoint registered",
				body: "Register an HTTPS endpoint and answer the challenge we send it. Deliveries for this environment start the moment it is active."
			},
			actions: {
				register: "Register endpoint",
				edit: "Edit endpoint",
				rotate: "Rotate secret",
				delete: "Delete endpoint"
			},
			rotate: {
				confirmTitle: "Rotate the signing secret?",
				confirmBody: "We'll issue a new secret and keep signing every delivery with both for an overlap window, so you can deploy the new one on your own schedule. The new secret is shown once.",
				secretWarning: "Store this now — it is never shown again. The previous secret keeps working until {{date}}.",
				secretHint: "Update your verifier to accept this secret, then remove the old one before the overlap ends.",
				copied: "I've stored it",
				error: "Could not rotate the secret"
			},
			delete: {
				confirmTitle: "Delete this endpoint?",
				confirmBody: "Delivery stops and the subscription is forgotten. Queued deliveries are parked as failed and can be redriven after you register again; your delivery history stays readable.",
				success: "Endpoint deleted",
				error: "Could not delete the endpoint"
			},
			test: {
				label: "Send a test event",
				hint: "Queues one real delivery of the chosen event, built from a fixed synthetic fixture, to this endpoint — same signature, same envelope, same retries. The body carries \"test\": true.",
				eventLabel: "Event",
				send: "Send test event",
				guide: "How test events work",
				inactive: "The endpoint has to be active first — answer the challenge, then send a test.",
				confirmTitle: "Send {{event}} to your endpoint?",
				confirmBody: "One delivery, over the fixture, counted against your test allowance for the day. It shows up in the Deliveries tab badged \"Test\".",
				success: "Test event queued",
				remaining_one: "{{count}} test event left today",
				remaining_other: "{{count}} test events left today",
				error: "Could not send the test event"
			},
			listeningFor: "Listening for",
			eventsCount_one: "{{count}} event",
			eventsCount_other: "{{count}} events",
			eventsMore: "+{{count}} more",
			eventsLess: "Show fewer",
			notVerified: "Not verified",
			challengeSentOn: "Challenge sent {{date}}",
			signingSecret: "Signing secret",
			generation: "Generation {{generation}}",
			overlapUntil: "The old and new secrets both sign until {{date}}",
			createdAt: "Registered",
			moreActions: "Endpoint actions",
			challengeHint: "Fix your handler, then save the endpoint again from Edit endpoint to send a new challenge.",
			suspendedTitle: "Deliveries to this endpoint are stopped",
			suspendedBody: "Register it again to resume — we'll re-run the checks and send a new challenge.",
			removedNote: "Your previous endpoint was deleted. Its deliveries are still listed under Deliveries."
		},
		challengeErrors: {
			egress_blocked: "The URL resolved to an address we refuse to call (private, local or otherwise blocked). Use a publicly reachable host.",
			http_error: "Your endpoint answered the challenge with a non-2xx status.",
			challenge_mismatch: "Your endpoint answered, but the challenge it echoed did not match the one we sent.",
			challenge_unreadable: "Your endpoint's answer was not JSON we could read a challenge from.",
			endpoint_unreachable: "We could not connect to your endpoint, or it did not answer in time."
		},
		deliveries: {
			stats: {
				pending: "Pending",
				retrying: "Retrying",
				delivered: "Delivered",
				failed: "Failed",
				redacted: "Redacted",
				oldestUndelivered: "Oldest: {{date}}"
			},
			allStatuses: "All"
		},
		events: {
			description: "Every event the platform can deliver. Subscribe from the endpoint; the docs carry each payload in full.",
			docsLink: "Payload docs",
			sendTest: "Send test",
			groups: {
				booking: "Bookings",
				review: "Reviews",
				listing: "Listings",
				pricing: "Pricing",
				calendar: "Calendar"
			}
		}
	},
	register: {
		title: "Register webhook endpoint",
		editTitle: "Edit webhook endpoint",
		urlLabel: "Endpoint URL",
		urlPlaceholder: "https://hooks.example.com/maat",
		urlHint: "HTTPS, on a publicly resolvable host, port 443 or 8443. We will POST a signed challenge to it during this call.",
		eventsLabel: "Events",
		eventsHint: "Choose the events to deliver",
		eventsGuide: "The event catalogue",
		challengeNote: "Your endpoint must echo the challenge we send while you register — the guide shows the exact exchange. A URL that answers something else is registered but not active.",
		submit: "Register",
		submitEdit: "Save and re-verify",
		submitError: "Could not register the endpoint",
		registeredTitle: "Endpoint registered",
		updatedTitle: "Endpoint updated",
		verifiedNote: "Your endpoint echoed the challenge — it is active and will receive deliveries.",
		notVerifiedNote: "Your endpoint did not echo the challenge. It is registered but not active; fix the handler and save again to re-send the challenge.",
		secretWarning: "Store this signing secret now — it is never shown again.",
		secretHint: "Verify every delivery's X-Signature with it, over the raw body. Rotate it from the endpoint page if it ever leaks.",
		secretUnchanged: "Your signing secret is unchanged.",
		done: "I've stored the secret",
		validation: {
			urlRequired: "Enter the endpoint URL",
			urlHttps: "Enter a valid https:// URL",
			eventsMin: "Choose at least one event"
		}
	},
	sandboxPage: {
		title: "Sandbox",
		description: "A paired workspace where your integration can be exercised without touching anything real.",
		what: {
			body: "A second workspace, paired with this one, flagged as a sandbox. Sandbox keys and the sandbox endpoint address it and nothing else; production data never enters it.",
			workspace: "Workspace",
			provisioned: "Provisioned"
		},
		keys: {
			title: "Sandbox keys",
			count_one: "{{count}} active key",
			count_other: "{{count}} active keys",
			manage: "Manage sandbox keys"
		},
		cannot: {
			title: "What the sandbox cannot prove",
			body: "No guest ever pays in a sandbox, so nothing books on its own. The sandbox booking fixture on the API mints a real booking on sandbox inventory so the booking events fire, and test events exercise your webhook handler over a fixture; the guide lists what only the live workspace can show you.",
			guide: "Read the sandbox guide"
		},
		summary: {
			title: "Your sandbox",
			lastReset: "Last reset",
			schedule: "Automatic reset",
			nightly: "Every night"
		},
		resetScope: {
			title: "What a reset does",
			cleared: {
				title: "Cleared",
				written: "Everything your integration wrote",
				bookings: "Every booking, including the ones the booking fixture made",
				settings: "Every property and setting, back to a clean slate"
			},
			kept: {
				title: "Kept",
				workspace: "The sandbox workspace itself",
				keys: "Your sandbox keys, which keep working",
				endpoint: "Your sandbox webhook endpoint"
			}
		}
	}
};
//#endregion
export { e as default };
